import GLightbox from 'glightbox';

const groupedImages = (selector) => {
  let _groupedImages = [];
  let _group = [];
  document.querySelectorAll(selector).forEach((el) => {
    if (el.querySelector('* > img')) {
      _group.push(el);
      if (!el.nextElementSibling || el.nextElementSibling.nodeName !== 'FIGURE') {
        _groupedImages.push(_group);
        _group = [];
      }
    }
  });
  return _groupedImages;
};

export default function () {
  groupedImages(
    '.group-figures-having-images > figure:not(.no-grouping), .group-figures-having-images li > figure:not(.no-grouping)'
  ).forEach((group, groupNumber) => {

    let createLightbox = true;
    let container = document.createElement('div');

    const appendImagesToGroupContainer = (fig, i) => {
      let isSingleImage = group.length === 1;
      let link = document.createElement('a');

      if (isSingleImage) {
        // we have only one picture here
        container.classList.add('single-image');
        container.classList.add(...fig.classList);
        fig.classList.remove(...fig.classList);
      } else {
        link.classList.add(...fig.classList);
        fig.classList.remove(...fig.classList);
      }

      if ((fig.querySelector('a') && fig.querySelector('a').classList.contains('lightbox')) || fig.parentElement.tagName === 'A' || fig.querySelector('* > a')) {
        createLightbox = false;
      }

      let parentArticleContainer = fig.closest('article');

      if (createLightbox) {
        let img = fig.querySelector('img');
        let caption = fig.querySelector('figcaption') && fig.querySelector('figcaption').textContent || img.getAttribute('alt');

        if (isSingleImage && parentArticleContainer && img.naturalWidth <= parentArticleContainer.clientWidth) {
          // doesn't add lightbox if the image is a single image and is smaller then the parent (article) container
        } else {
          link.setAttribute('href', img.getAttribute('src'));
          link.classList.add('glightbox');
          if (link.getAttribute('href').match('res.cloudinary.com')) {
            link.dataset['type'] = 'image';
          }
        }

        link.dataset.gallery = 'lightbox-gallery-' + groupNumber;
        if (caption && caption.trim()) {
          link.dataset.description = caption;
        }
        link.append(fig.cloneNode(true));
        container.append(link);
      } else {
        container.append(fig.cloneNode(true));
      }

      if (i === 0) {
        fig.replaceWith(container);
      } else {
        fig.remove();
      }
    };

    if (group.length < 1) {
      return;
    }


    container.classList.add('figures');
    if (group.length % 2 === 1) {
      container.classList.add('odd-count');
    }
    group.forEach(appendImagesToGroupContainer);

  });

  GLightbox({ autoplayVideos: false });

};